import { Box, Flex, Text } from '@televet/kibble-ui';
import partial from 'lodash-es/partial';
import { default as React } from 'react';
import { ChatEntityType } from '../enums/ChatEntityType';
import { AttachmentFormData } from '../types/AttachmentFormData';
import { FormListItem } from './FormListItem';

type FormListProps = {
  forms: AttachmentFormData[];
  handleChatEntitySelect: (id: string, type: ChatEntityType) => void;
};

export const FormList = ({ forms, handleChatEntitySelect }: FormListProps): JSX.Element => {
  return (
    <Box overflow="auto">
      <Flex direction="column" mt={1} mx={1}>
        {forms.length ? (
          forms.map((formData) => (
            <FormListItem
              key={formData.id}
              formData={formData}
              onClick={partial(handleChatEntitySelect, formData.id, ChatEntityType.Form)}
            />
          ))
        ) : (
          <Text size="sm" mx={1}>
            This client has no forms
          </Text>
        )}
      </Flex>
    </Box>
  );
};
